import {ForecastMapFrame} from '../../api/types';

// Which image the active view actually displays for a frame: the interactive
// map drapes the small Web-Mercator overlay (~100-250 kB), the flipbook shows
// the full styled render (1-2.5 MB on global models). Preloading must follow
// the view, otherwise interactive playback warms megabytes of styled frames
// that are never shown (a 209-frame GFS loop ≈ 300 MB of wasted fetches).
export type FramePreloadMode = 'overlay' | 'flipbook';

export const frameImageUrl = (
  frame: ForecastMapFrame | undefined,
  mode: FramePreloadMode,
): string | undefined =>
  mode === 'overlay'
    ? frame?.overlay_url ?? undefined
    : frame?.webp_url ?? frame?.png_url ?? undefined;
